<template>
  <div class="help-container">
    <Header @cart-ref="setCartRef" />
    
    <div class="help-hero">
      <h1>Como podemos ajudar?</h1>
      <p>Encontre respostas para as perguntas mais comuns ou entre em contato com nossa equipe de suporte.</p>
    </div>

    <div class="help-content">
      <div class="faq-section">
        <h2>Perguntas Frequentes</h2>
        
        <div 
          v-for="(faq, index) in faqs" 
          :key="index" 
          class="faq-item"
          :class="{ active: activeIndex === index }"
        >
          <button class="faq-question" @click="toggleFaq(index)">
            {{ faq.question }}
            <i class="fa-solid fa-chevron-down faq-icon"></i>
          </button>
          <div class="faq-answer">
            <p>{{ faq.answer }}</p>
          </div>
        </div>
      </div>

      <div class="contact-section">
        <h3>Ainda precisa de ajuda?</h3>
        <p>Nossa equipe está pronta para tirar todas as suas dúvidas.</p>
        <div class="contact-buttons">
          <a href="https://wa.me/5511985590407" target="_blank" class="btn-contact btn-whatsapp">
            <i class="fa-brands fa-whatsapp"></i> Falar no WhatsApp
          </a>
          <a href="mailto:junior@unimaisedu.com.br" class="btn-contact btn-email">
            <i class="fa-regular fa-envelope"></i> Enviar E-mail
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import '../styles/HelpCenter.css';

export default {
  name: 'HelpCenter',
  components: {
    Header
  },
  data() {
    return {
      activeIndex: null,
      cartComponent: null,
      faqs: [
        {
          question: 'Como acesso meus cursos?',
          answer: 'Você terá acesso ao link de um iframe para colocar os conteúdo na sua plataforma para os alunos de suas instituições.'
        },
        {
          question: 'Quais são as formas de pagamento aceitas?',
          answer: 'Aceitamos pagamentos via Recorrência no cartão de crédito.'
        },
        {
          question: 'Como funciona a recorrência no cartão de crédito?',
          answer: 'Você cadastra o cartão de crédito uma única vez e o valor é debitado todos os meses. '   
        },
        {
          question: 'Como funciona o cancelamento?',
          answer: 'O cancelamento será efetuado no fim do ciclo de faturamento vigente da compra dos materiais.'
        },
        {
          question: 'Como funciona a renovação?',
          answer: 'As renovações são manuais. Você deve renovar os materiais no site antes do fim do ciclo de faturamento para continuar tendo acesso aos cursos.'  
        },
      ]
    };
  },
  methods: {
    toggleFaq(index) {
      if (this.activeIndex === index) {
        this.activeIndex = null; // Close if clicked again
      } else {
        this.activeIndex = index; // Open clicked one
      }
    },
    setCartRef(cartRef) {
      this.cartComponent = cartRef;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>
